// @flow
/* ***************************************************************************
* @author Afonso Bordado (abordado@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import { toastr } from "react-redux-toastr"
import { connect } from "react-redux"

import Hidable from "../Hidable"
import Spacer from "../Spacer"
import FileUpload from "../FileUpload"
import FontIcon from "react-toolbox/lib/font_icon/FontIcon"
import Dialog from "react-toolbox/lib/dialog/Dialog"

import styles from "./styles.css"
import path from "path"
import * as strings from "../../strings"
import { unparsedTokenCommand } from "../../actions"

import download from "downloadjs"

type Document = {} // TODO: Complete This type

class DebtPhaseDocuments extends Component {
  props: {
    documents: Document[],
    onChange: () => any,

    phaseId: number,
    fileDownloadCommand: string,

    fileUploadCommand: string,
    fileUploadArgs: {},

    fileRemoveCommand: string,

    expanded?: boolean,
    onToggle?: () => any,

    disabled?: boolean,

    auth: any,
  }

  state = {
    deleteDocId: undefined,
    showDeleteDialog: false,
  }

  hideDialog = () => this.setState( {
    deleteDocId: undefined,
    showDeleteDialog: false,
  } )

  showDialog = docId => this.setState( {
    deleteDocId: docId,
    showDeleteDialog: true,
  } )

  showFileDeleteDialog = ( doc ) => () => this.showDialog( doc.id )

  deleteFile = () => {
    const documentId = this.state.deleteDocId
    unparsedTokenCommand( this.props.auth.token, {
      command: this.props.fileRemoveCommand,
      args: { documentId },
    } )
      .then( response => {
        if ( response.status !== 200 ) {
          throw new Error()
        }

        toastr.success( strings.generalStrings.documentDeleted )
        this.hideDialog()
        this.props.onChange( this.props.documents.filter( doc => doc.id !== documentId ) )

      } )
      .catch( () => {
        toastr.error( strings.generalStrings.errorDeletingDocument )
        this.hideDialog()
      } )
  }

  downloadFile = ( id: number, documentId: number, fileName: string ) => {

    unparsedTokenCommand( this.props.auth.token, {
      command: this.props.fileDownloadCommand,
      args: {
        id,
        documentId,
      },
    } )
      .then( response => {
        if ( response.status !== 200 ) {
          throw "Error downloading file"
        }

        const contentType = response.headers.get( "Content-type" )
        return response.blob()
          .then( blob => ( {
            contentType,
            blob,
          } ) )
      } )
      .then( file => download( file.blob, fileName, file.contentType ) )
      .catch( () => toastr.error( strings.errorMessages.downloadError ) )
  }

  render () {
    const disabled = ( this.props.disabled === undefined ) ? false : this.props.disabled
    const nonNullDocs = this.props.documents || []
    const documents = nonNullDocs.map( doc => ( {
      ...doc,
      name: path.basename( doc.file.path ),
      ext: path.extname( doc.file.path ),
    } ) )

    const shouldExpand = !disabled || this.props.expanded

    return (
      <Hidable
        title={strings.generalStrings.attachmentsAndDocuments}
        expanded={ shouldExpand }
        onToggle={shouldExpand ? this.props.onToggle : () => {} }
        titleStyle={{
          cursor: shouldExpand ? "pointer" : "not-allowed",
        }}
      >
        <div className={styles.card}>
          <table className={styles.fileList}>
            <tbody>
              {documents.map( doc => {
                const basename = path.basename( doc.file.path )
                const downloadFn = this.downloadFile
                  .bind( this, this.props.phaseId, doc.id, basename )
                return (
                  <tr key={doc.id || doc.name} className={styles.file}>
                    <td>
                      <FontIcon
                        className={styles.deleteIcon}
                        value="delete"
                        onClick={this.showFileDeleteDialog( doc )}
                      />
                    </td>
                    <td><Spacer size={1} /></td>
                    <td onClick={downloadFn}>
                      <div className={styles.fileExt}>{doc.ext}</div>
                    </td>
                    <td/>
                    <td onClick={downloadFn}>{doc.name}</td>
                  </tr>
                )
              } )}
            </tbody>
          </table>
          <Dialog
            actions={[
              { label: strings.generalStrings.cancel, onClick: this.hideDialog },
              { label: strings.generalStrings.delete, onClick: this.deleteFile },
            ]}
            active={this.state.showDeleteDialog}
            type="small"
          >
            Tem a certeza que pertende apagar este documento?
          </Dialog>
          <div className={styles.uploadWrapper}>
            <FileUpload
              command={this.props.fileUploadCommand}
              args={this.props.fileUploadArgs}
              onCompleteOk={( newDocuments ) => {
                this.props.onChange( [ ...this.props.documents, ...newDocuments ] )
              }}
            />
          </div>
        </div>
      </Hidable>
    )
  }
}

export default connect( store => ( {
  auth: store.auth,
} ) )( DebtPhaseDocuments )



// WEBPACK FOOTER //
// ./src/components/DebtPhaseDocuments/index.jsx